import { captureAnalytics } from '../../actions/preload';

const URGENCY_RANK = { normal: 0, warning: 1, urgent: 2 };

export const getSessionUrgency = (seconds) => {
  if (seconds == null) return 'normal';
  if (seconds <= 5 * 60) return 'urgent';
  if (seconds <= 10 * 60) return 'warning';
  return 'normal';
};

// A collapsed banner must resurface when the remaining time crosses into a
// more urgent bucket. Both countdown paths go through this: the 1s tick and
// the server resync restart, which can jump several buckets at once (e.g. a
// throttled background tab correcting from 12 min straight to 4 min). Rank
// comparison (not inequality) keeps the banner collapsed when a resync
// extends the session into a calmer bucket.
export const shouldReexpandImpersonationBanner = ({ collapsed, prevSeconds, nextSeconds }) => {
  if (!collapsed) return false;

  return URGENCY_RANK[getSessionUrgency(nextSeconds)] > URGENCY_RANK[getSessionUrgency(prevSeconds)];
};

export const trackImpersonationBannerToggle = (collapsed, track = captureAnalytics) => {
  track(collapsed ? 'impersonation_banner_collapsed' : 'impersonation_banner_expanded');
};
